import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { MilestoneReport } from "@shared/models/payouts.types";

@Component({
	selector: "app-payment-top-cards",
	templateUrl: "./payment-top-cards.component.html",
	styleUrls: ["./payment-top-cards.component.scss"]
})
export class PaymentTopCardsComponent implements AfterViewInit {
	@ViewChild("payment", { static: false }) payment!: ElementRef;

	@Input() milestoneReport!: MilestoneReport;
	@Input() title!: string;
	@Input() subTitle!: string;
	@Input() flag!: string;
	@Input() expandMilestoneGroupWithName!: string;
	@Input() kpiSelected!: string;

	@Input() set _updating(update: boolean) {
		this.updating = update;
	}

	headcountTooltip: string = "";
	transactionTooltip: string = "";
	totalPaymentTooltip: string = "";
	showTooltipHead: boolean = false;
	showTooltipPayment: boolean = false;
	showTooltipTransactions: boolean = false;
	minWidth: number = 341;
	updating: boolean = false;
	isCPNowDeductionsEnabled = false;

	constructor(private router: Router) {}

	ngOnInit(): void {
		if (history.state && history.state.payGroup) {
			this.isCPNowDeductionsEnabled = history.state.payGroup.data.cpNowDeductionsEnabled;
		}
	}

	ngAfterViewInit() {
		setTimeout(() => {
			this.getWidth();
		}, 200);
	}

	getWidth() {
		if (this.payment) {
			const elementWidth = this.payment.nativeElement.offsetWidth;
			this.minWidth = elementWidth;
		}
	}

	regress(): void {
		let route = "payments";

		if (this.router.url.includes("global-dashboard")) route = "global-dashboard";

		if ((this.kpiSelected === "Failed Transactions" || this.kpiSelected === "") && route === "global-dashboard") {
			this.router.navigate([`/${route}`]);
		} else {
			this.router.navigate([`/${route}/dashboard`], {
				state: { expandMilestoneGroupWithName: this.expandMilestoneGroupWithName }
			});
		}
	}
}
